import { bool, number, node, object, func, arrayOf, string, oneOfType } from "prop-types";
import { observer } from "mobx-react";
import { SortableList } from "@components";
import { TimelineUtilizationTeamMember } from "./TimelineUtilizationTeamMember";
import { TimelineUtilizationWorkType } from "./TimelineUtilizationWorkType";

export const TimelineUtilizationRowGroupList = observer(({
  disabled,
  listElements,
  onReorder,
  children,
  hashedPath,
  renderTeamMembers,
}) => (
  <>
    <SortableList
      list={listElements}
      path={hashedPath.join("/")}
      group={hashedPath.join("/")}
      onListReorder={onReorder}
      displayAsColumnFlexbox
      disabled={disabled}
    >
      {listElements?.map((child) =>
        renderTeamMembers ? (
          <TimelineUtilizationTeamMember
            key={`element${child.id}`}
            teamMember={child}
          />
        ) : (
          <TimelineUtilizationWorkType
            key={`element${child.id}`}
            workType={child}
          />
        )
      )}
    </SortableList>
    {children}
  </>
));

TimelineUtilizationRowGroupList.propTypes = {
  renderTeamMembers: bool,
  listElements: arrayOf(object),
  onReorder: func,
  
  hashedPath: arrayOf(oneOfType([number, string])),
  children: node,
  disabled: bool,
};
